export default __webpack_public_path__ + "static/media/amazon.f88d7386.svg";